import { cn } from '@/utils/tailwind-util';

export const InfoTriangle = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '37'}
    height={height || '35'}
    viewBox={viewBox || '0 0 37 35'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(styles)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3169 3.43698C16.152 0.174653 20.849 0.174651 22.6841 3.43698L36.0768 27.2463C37.8766 30.446 35.5644 34.3995 31.8932 34.3995H5.10777C1.4366 34.3995 -0.875625 30.446 0.924206 27.2463L14.3169 3.43698ZM20.9003 27.1998C20.9003 28.5253 19.8258 29.5998 18.5003 29.5998C17.1748 29.5998 16.1003 28.5253 16.1003 27.1998C16.1003 25.8743 17.1748 24.7998 18.5003 24.7998C19.8258 24.7998 20.9003 25.8743 20.9003 27.1998ZM18.5003 7.9998C17.1748 7.9998 16.1003 9.07432 16.1003 10.3998V17.5998C16.1003 18.9253 17.1748 19.9998 18.5003 19.9998C19.8258 19.9998 20.9003 18.9253 20.9003 17.5998V10.3998C20.9003 9.07432 19.8258 7.9998 18.5003 7.9998Z"
      fill={fill || '#4F64D7'}
    />
  </svg>
);
